import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_loggedIn/$organizationId/")({
	component: Outlet,
	beforeLoad: ({ context: { activeProjectId } }) => {
		if (!activeProjectId) {
			throw redirect({ from: "/$organizationId", to: "/$organizationId/projects" })
		}

		throw redirect({
			from: "/$organizationId",
			to: "/$organizationId/$projectId",
			params: (prev) => ({ ...prev, projectId: activeProjectId }),
		})
	},
})
